import React from 'react';
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    IconButton,
    MenuItem,
    Select, Slider, Tab,
    Tabs,
    TextField,
    Typography
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Map, {Popup,Source, Layer} from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import PauseIcon from '@mui/icons-material/Pause';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import dayjs from 'dayjs';
import ApiCtrl from "../../svc/ApiCtrl";

import * as turf from "@turf/turf";
import {MAPBOX_TOKEN} from "./MapBlaster";



export default function RightView({path, result, year, nday, initYear}) {

    const [loading, setLoading] = React.useState(true);

    const [speed, setSpeed] = React.useState(10);

    const [timeTravelStep, setTimeTravelStep] = React.useState(1);
    const [timeTravelRun, setTimeTravelRun] = React.useState(false);

    const subCounter = React.useRef(0);
    const [counter, setCounter] = React.useState(0);


    const r = React.useRef(null);
    r.current = {counter, setCounter};

    const speedRef = React.useRef(null);
    speedRef.current = {speed, setSpeed};

    const [rawMap, setRawMap] = React.useState({"type": "FeatureCollection", "features": []});
    const [rawMinMax, setRawMinMax] = React.useState({min: 0, max: 0});


    const [burstMap, setBurstMap] = React.useState({"type": "FeatureCollection", "features": []});


    const [coords, setCoords] = React.useState(null);
    const [hoverInfo, setHoverInfo] = React.useState(null);


    const [viewState, setViewState] = React.useState(null);

    const onMove = React.useCallback(evt => setViewState(evt.viewState), []);


    function updateTimeTravelStep() {
        if (timeTravelRun) {
            if (timeTravelStep >= 365) {
                setTimeTravelRun(false);
            } else {

                setTimeTravelStep(timeTravelStep + 1)
            }
        }
    }

    function formatDateFromNb() {
        let date = new Date(year, 0); // initialize a date in `year-01-01`
        let d = new Date(date.setDate(timeTravelStep)); // add the number of days
        return dayjs(d).format("YYYY-MM-DD")

    }


    React.useEffect(
        () => {
            const id = setInterval(() => {
                subCounter.current++;
                if (subCounter.current > 10 - speedRef.current.speed) {
                    subCounter.current = 0;
                    r.current.setCounter(r.current.counter + 1);
                }

            }, 100);
            return () => {
                clearInterval(id);
            };
        }, []);

    React.useEffect(() => {
        if (year && nday) {
            setTimeTravelStep(nday);
        }
    }, [nday, year])


    function generateValue(vv) {
        let value = -999999999;
        if (result.tile.params === "sst") {
            if (vv !== 'NaN') {
                value = parseFloat(vv)
            }
        } else {
            if (vv !== "0.0") {
                value = parseFloat(vv)
            }
        }
        return value;
    }


    function generateBurstValue2(vv) {
        let value = -999999999;
        if (vv !== "NaN") {
            value = parseFloat(vv)
        }
        return value;
    }

    React.useEffect(() => {
        if (timeTravelStep) {
            let step = (year - initYear) * 365 + timeTravelStep - 1;
            ApiCtrl.getRawTile(path, step, (resCsv) => {
console.log(resCsv);
                const latitudes = resCsv.latitudes;
                const longitudes = resCsv.longitudes;
                let data = {
                    "type": "FeatureCollection",
                    "features": []
                }

                let min_lat = latitudes.reduce((a, b) => Math.min(a, b));
                let max_lat = latitudes.reduce((a, b) => Math.max(a, b));
                let min_lon = longitudes.reduce((a, b) => Math.min(a, b));
                let max_lon = longitudes.reduce((a, b) => Math.max(a, b));
                if (!viewState) {

                    setViewState({
                        bounds: [[min_lon, min_lat], [max_lon, max_lat]]
                    })
                }

                let min = 999999999;
                let max = -999999999;

                const diffLon = Math.abs(longitudes[0] - longitudes[1]) / 2
                const diffLat = Math.abs(latitudes[0] - latitudes[1]) / 2

                resCsv.values.forEach((v, i) => {
                    v.split(',').forEach((vv, j) => {
                        let value = generateValue(vv);

                        const tile = {
                            "type": "Feature",
                            "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                    [
                                        [longitudes[j] - diffLon, latitudes[i] - diffLat],
                                        [longitudes[j] + diffLon, latitudes[i] - diffLat],
                                        [longitudes[j] + diffLon, latitudes[i] + diffLat],
                                        [longitudes[j] - diffLon, latitudes[i] + diffLat],
                                        [longitudes[j] - diffLon, latitudes[i] - diffLat]
                                    ]
                                ]
                            },
                            "properties": {"value": value}
                        }
                        if (value !== -999999999) {
                            data.features.push(tile)

                        }
                        if (value > max) {
                            max = value;
                        }
                        if (value !== -999999999 && value < min) {
                            min = value;
                        }
                    })
                })
                setRawMap(data)
                setRawMinMax({"min": min, "max": max})
            })

            ApiCtrl.getBurstTile(path, step, (resCsv) => {
                const latitudes = resCsv.latitudes;
                const longitudes = resCsv.longitudes;
                let data = {
                    "type": "FeatureCollection",
                    "features": []
                }
                resCsv.values.forEach((v, i) => {
                    v.split(',').forEach((vv, j) => {
                        let value = generateBurstValue2(vv);
                        const tile = {
                            "type": "Feature",
                            "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                    [
                                        [longitudes[j] - 0.125, latitudes[i] - 0.125],
                                        [longitudes[j] + 0.125, latitudes[i] - 0.125],
                                        [longitudes[j] + 0.125, latitudes[i] + 0.125],
                                        [longitudes[j] - 0.125, latitudes[i] + 0.125],
                                        [longitudes[j] - 0.125, latitudes[i] - 0.125]
                                    ]
                                ]
                            },
                            "properties": {"value": value}
                        }
                        if (value !== -999999999 && value !== 0) {

                            data.features.push(tile)
                        }
                    })
                })
                setBurstMap(data)
            })
        }
    }, [timeTravelStep, result])

    React.useEffect(() => {
        if (timeTravelRun) {
            updateTimeTravelStep();
        }
    }, [counter]);

    /*    React.useEffect(() => {
            if (year) {
                setTimeTravelStep(121)
            }
        }, [year])*/


    React.useEffect(() => {
            if (timeTravelStep && burstMap && viewState) {
                setLoading(false)
            }
        }, [timeTravelStep, burstMap, viewState]
    )


    function computeOpacity(min, max) {
        let res = []
        if (result.tile.params === "sst") {
            res = [
                [-999999999, 0],
                [min, 0.8],
                [max, 0.8],
                [999999999, 0]
            ]
        } else {
            res = [
                [min, min],
                [max, 1],
            ]
        }

        return res;
    }

    function computeColorScale(min, max) {
        let res = [
            [-999999999, '#0000FF'],
            [min + (0 * (max - min) / 5), '#0000FF'],
            [min + (1 * (max - min) / 5), '#3300CC'],
            [min + (2 * (max - min) / 5), '#660099'],
            [min + (3 * (max - min) / 5), '#990066'],
            [min + (4 * (max - min) / 5), '#CC0033'],
            [min + (5 * (max - min) / 5), '#ff0000'],
            [999999999, '#ff0000']
        ]
        return res;
    }


    if (loading) {
        return (
            <Paper elevation={3}
                   sx={{
                       width: "48%", height: "95%", display: "flex",
                       alignItems: "center",
                       justifyContent: "center"
                   }}>

                <CircularProgress/>
            </Paper>)
    }

    return (
        <Paper elevation={3} sx={{width: "48%", height: "98%", display: "flex", flexDirection: "column", p: 1}}>
            <Box
                sx={{
                    mt: 1, ml: 5, mr: 5,
                    display: "flex",
                    width: "90%",
                    justifyContent: "space-between"
                }}>
                <Box sx={{
                    display: "flex", flexDirection: "column",
                }}>
                    <Box sx={{display: "flex"}}>
                        <Typography variant="h6">Selected year:</Typography>
                        <Typography variant="h6" sx={{fontWeight: 'bold'}}>&nbsp;{year}</Typography>
                    </Box>
                    <Box sx={{display: "flex"}}>
                        <Typography variant="h6">Time travel date:</Typography>
                        <Typography variant="h6" sx={{fontWeight: 'bold'}}>&nbsp;{formatDateFromNb()}</Typography>
                    </Box>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", flexDirection: "column", width: 100}}>
                    <Typography variant="h6">Speed:</Typography>
                    <Box sx={{display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center"}}>
                        <IconButton>
                            <RemoveCircleOutlineIcon onClick={() => {
                                if (speed - 1 > 0) {
                                    setSpeed(speed - 1)
                                }
                            }}/>
                        </IconButton>
                        <Typography variant="h6">{speed}</Typography>
                        <IconButton>
                            <AddCircleOutlineIcon onClick={() => {
                                if (speed + 1 <= 20) {
                                    setSpeed(speed + 1)
                                }
                            }}/>
                        </IconButton>
                    </Box>

                </Box>
            </Box>
            <Box sx={{
                m: 1,
                display: "flex",
                flexDirection: "column",
                width: "98%",
                height: "45%"
            }}>
                <Map
                    width="95%"
                    {...viewState}
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                    mapboxAccessToken={MAPBOX_TOKEN}
                    dragPan={true}

                    onMouseMove={(event) => {
                        let filter = rawMap.features.filter((county) => {
                            return turf.booleanPointInPolygon(turf.point([event.lngLat.lng, event.lngLat.lat]), county);
                        });
                        if (filter && filter.length > 0) {
                            let centroid = turf.centroid(filter[0]);
                            if (filter[0].properties.value !== -999999999) {
                                setCoords(centroid.geometry.coordinates);
                                setHoverInfo(filter[0].properties.value);
                            }
                        } else {
                            setCoords(null)
                            setHoverInfo(null)
                        }

                    }}

                    onMove={onMove}


                >
                    <Source type="geojson" data={rawMap}>
                        <Layer
                            type={'fill'}
                            paint={{
                                'fill-color': {
                                    property: 'value',
                                    stops: computeColorScale(rawMinMax.min, rawMinMax.max)
                                },
                                'fill-opacity': {
                                    property: 'value',
                                    stops: computeOpacity(rawMinMax.min, rawMinMax.max)
                                },
                            }}
                        />

                    </Source>
                    {false && coords && (
                        <Popup
                            longitude={coords[0]}
                            latitude={coords[1]}
                            anchor="top"
                            onClose={() => setCoords(null)}>

                            <Typography variant="h6">Value: {hoverInfo}</Typography>

                        </Popup>)}
                </Map>
            </Box>
            <Box sx={{width: "90%", ml: 5, mr: 5, display: "flex", alignItems: "center"}}>
                <Slider
                    value={timeTravelStep}
                    min={1}
                    max={365}
                    onChange={(event, value) => {
                        setTimeTravelStep(value)
                    }}
                    size="small"
                />
                <IconButton>
                    {timeTravelRun && <PauseIcon onClick={() => {
                        setTimeTravelRun(false)
                    }}/>}
                    {!timeTravelRun && <PlayCircleFilledWhiteIcon onClick={() => {
                        setTimeTravelRun(true)
                    }}/>}
                </IconButton>
            </Box>
            <Box sx={{
                m: 1,
                display: "flex",
                flexDirection: "column",
                width: "98%",
                height: "45%"
            }}>
                <Map
                    width="100%"
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                    {...viewState}
                    dragPan={true}
                    mapboxAccessToken={MAPBOX_TOKEN}
                    onMove={onMove}
                >
                    <Source type="geojson" data={burstMap}>
                        <Layer
                            type={'fill'}
                            paint={{
                                'fill-color': {
                                    property: 'value',
                                    stops: [
                                        [-999999999, '#0000FF'],
                                        [-1, '#0000FF'],
                                        [0, '#990066'],
                                        [1, '#ff0000'],
                                        [999999999, '#ff0000']
                                    ]
                                },
                                'fill-opacity': {
                                    property: 'value',
                                    stops: [
                                        [-999999999, 0],
                                        [-1, 0.8],
                                        [0, 0.8],
                                        [1, 0.8],
                                        [999999999, 0]
                                    ]
                                },
                            }}
                        />

                    </Source>
                </Map>
            </Box>
        </Paper>
    )
}
